export const SIDE_NAV_ID = 'side-nav';
